import type { EthereumAddress, } from "@bracket/types";


export declare type ApplyClaimProps = {
	email: string;
	amount: bigint;
	address: EthereumAddress;
};

export const applyClaim = async ({ email, amount, address, }: ApplyClaimProps): Promise<boolean> => {

	try {

		if(email.startsWith("0x") && email.endsWith("@bracket.fi")) {
			return true;
		}

		const response = await fetch("/api/vaults/graphql", {
			method: "POST",
			body: JSON.stringify({
				operationName: "apply_claim",
				query: "  mutation apply_claim($email: String!, $amount: String!) {\n    apply_claim(email: $email, amount: $amount)\n  }",
				variables: {
					email,
					amount: amount.toString(),
				},
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				wallet: address,
			},
		});

		if(response.ok) {
			const data = await response.json();
			return data.data.apply_claim;
		}

		return false;

	}
	catch( err ) {

		console.warn(`@bracket/platform/client/store/wallet/resolvers/escrow/applyClaim has failed - ${err instanceof Error ? err.message : "unknown error"}`);
		return false;
	}

};
